module.exports = {"510723001":"凤灵街道","510723100":"云溪镇","510723101":"玉龙镇","510723102":"富驿镇","510723103":"金孔镇","510723105":"黄甸镇","510723113":"巨龙镇","510723114":"高渠镇","510723115":"鹅溪镇","510723116":"岐伯镇","510723117":"文通镇","510723118":"永泰镇","510723119":"九龙镇","510723120":"西陵镇","510723121":"嫘祖镇","510723211":"大兴回族乡","510723222":"莲花湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510723.json
// module id = 2434
// module chunks = 0